import {
  ENDPOINT_CONNECT_STATUS_STORAGE_KEY,
  ENDPOINT_CONNECT_STATUSES,
} from 'xm-constants/endpointConnectionStatuses';

/**
 * This module use Local Storage and a listener to it changing to communicate the result of the endpoint OAuth2
 * Authorization process with a 3rd party. This is necessary because the 3rd party part of this process is handled in a
 * separate tab. When completed, the 3rd party service navigates to the redirect URL with the authorization result which
 * is handled by the OAuthProxyRedirect component.
 */

/** Pull the connect statuses (all of them) out of localStorage (if existent) */
function getConnectStatusStorage() {
  let connectStatusStorage = {};
  try {
    connectStatusStorage = JSON.parse(
      window.localStorage.getItem(ENDPOINT_CONNECT_STATUS_STORAGE_KEY) || '{}',
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(
      `Unable to parse local storage: '${ENDPOINT_CONNECT_STATUS_STORAGE_KEY}'. It will be re-initialized.`,
    );
    window.localStorage.setItem(
      ENDPOINT_CONNECT_STATUS_STORAGE_KEY,
      JSON.stringify(connectStatusStorage),
    );
  }

  return connectStatusStorage;
}

/** Return an individual connect status */
function getEndpointConnectStatus(endpointId) {
  const connectStatusStorage = getConnectStatusStorage();

  return connectStatusStorage[endpointId];
}

/** Set a specific connect status in localStorage */
export function setEndpointConnectStatus(endpointId, status) {
  const connectStatusStorage = getConnectStatusStorage();

  connectStatusStorage[endpointId] = status;
  return window.localStorage.setItem(
    ENDPOINT_CONNECT_STATUS_STORAGE_KEY,
    JSON.stringify(connectStatusStorage),
  );
}

/** Subscribe to localStorage and listen for changes to our specific endpoint status */
export function waitForConnectStatusChange(endpointId) {
  setEndpointConnectStatus(endpointId, ENDPOINT_CONNECT_STATUSES.CONNECTING);

  return new Promise((resolve, reject) => {
    const connectStatusChangeHandler = () => {
      const checkOurStatus = getEndpointConnectStatus(endpointId);
      switch (checkOurStatus) {
        case ENDPOINT_CONNECT_STATUSES.CONNECTED: {
          window.removeEventListener('storage', connectStatusChangeHandler);
          resolve();
          break;
        }
        case ENDPOINT_CONNECT_STATUSES.FAILED: {
          window.removeEventListener('storage', connectStatusChangeHandler);
          reject('Rejected by 3rd party');
          break;
        }
        default:
        // No action is taken for ENDPOINT_CONNECT_STATUSES.CONNECTING
      }
    };

    window.addEventListener('storage', connectStatusChangeHandler);
  });
}
